'use strict';

module.exports = (app) => app.controller('rfqToDemandController', /* @ngInject */ function ($scope, demandService) {

    $scope.copyFromRfq = copyFromRfq;
    $scope.copyFromQuotation = copyFromQuotation;

    /**
     * @param rfqFallbackId {string}
     * @returns {Promise<void>}
     */
    async function copyFromRfq(rfqFallbackId) {
        // if there are multiple tabs, we need to get the currently active one. Otherwise we can just use the fallback id
        const rfqId = getCurrentlyActiveRfqId() ?? rfqFallbackId;
        await demandService.copyFromRfq(+rfqId, true);
        window.navigateToPurchaseRequisition('client/rfq/demand/create');
    }

    /**
     * @param rfqFallbackId {string}
     * @returns {Promise<void>}
     */
    async function copyFromQuotation(rfqFallbackId) {
        // if there are multiple tabs, we need to get the currently active one. Otherwise we can just use the fallback id
        const rfqId = getCurrentlyActiveRfqId() ?? rfqFallbackId;
        await demandService.copyFromRfq(+rfqId, false);
        window.navigateToPurchaseRequisition('client/rfq/demand/create');
    }

    function getCurrentlyActiveRfqId() {
        const activeTabs = document.getElementsByClassName('dijitVisible');
        for (const tab of activeTabs) {
            if (tab && tab.hasAttribute('role') && tab.getAttribute('role') === 'tabpanel') {
                const rfqId = tab.querySelector('.rfq-id-display')
                if (rfqId) {
                    return rfqId.innerText;
                }
            }
        }
    }
});

